import React from 'react'

export default class TreeImages extends React.Component {
  constructor(props) {
    super(props)
    this.imageLoadControl = this.imageLoadControl.bind(this)
  }

  imageLoadControl() {
    if (this.props.imagesLoaded < this.props.images.length) this.props.imageLoad();
  }

  render() {
    const treeOpacity = this.props.imagesLoaded >= this.props.images.length ? 1 : 0
    return (
      <section className="tree-image-container">
        {this.props.images.map((image, i) => {
            const treeStyle = {
              opacity: treeOpacity
            }
            return (
              <img className={'image' + i}
                style={treeStyle}
                onLoad={this.imageLoadControl.bind(this)}
                src={image.imageSrc}
                alt="pretty trees"
                key={'tree' + i}
              />
            )
          })
        }
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page-specific/TreeImages.js